import { Components } from '@formio/js';
import { ApplicationRef, ComponentRef, createComponent, Injector } from '@angular/core';
import { DateTimePickerComponent } from './datetime-picker.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { environmentInjector } from '../../../shared/formio-environment';
import { CustomDateAdapter } from '../../../shared/custom-date-adapter';

const Field = (Components as any).components.field;

export class DateTimePickerFormioComponent extends Field {
    constructor(...args: any[]) {
        super(...args);
    }

    static schema(...extend) {
        return Field.schema({
            type: 'dateTimePicker',
            label: 'Data e Hora',
            key: 'dateTimePicker',
            ...extend,
        });
    }

    static get builderInfo() {
        return {
            title: 'Data e Hora',
            selector: 'datetime-picker',
            icon: 'fa fa-calendar',
            group: 'advanced',
            weight: 52,
            schema: DateTimePickerFormioComponent.schema(),
        };
    }

    angularRef?: ComponentRef<DateTimePickerComponent>;

    render(children) {
        return super.render(`<div class="formio-angular-host"></div>`);
    }

    attach(element) {
        const result = super.attach(element);

        const host = element.querySelector('.formio-angular-host');
        if (!host) return result;

        if (!environmentInjector) {
            console.warn('No EnvironmentInjector found');
            return result;
        }

        this.angularRef = createComponent(DateTimePickerComponent, {
            environmentInjector: environmentInjector,
            hostElement: host,
            elementInjector: Injector.create({
                providers: [
                    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
                    { provide: NgxMatDateAdapter, useClass: CustomDateAdapter },
                ],
                parent: environmentInjector,
            }),
        });

        Object.assign(this.angularRef.instance, {
            disabled: this.disabled,
            value: this.dataValue
        });

        this.angularRef.instance._value = this.dataValue;
        this.angularRef.instance._valueChange.subscribe((val) => this.setValue(val, {}));

        const appRef = environmentInjector.get(ApplicationRef);
        appRef.attachView(this.angularRef.hostView);

        this.on('destroy', () => {
            appRef.detachView(this.angularRef.hostView);
            this.angularRef.destroy();
        });

        return result;
    }

    setValue(value, flags) {
        super.setValue(value, flags);
        if (this.angularRef?.instance && this.angularRef.instance._value !== value) {
            this.angularRef.instance._value = value;
        }
    }

    detach() {
        if (this.angularRef) {
            this.angularRef.destroy();
            this.angularRef = undefined;

            if (this.appRef) {
                this.appRef.detachView(this.angularRef.hostView);
                this.appRef = undefined;
            }
        }
        super.detach();
    }
}

Components.addComponent('dateTimePicker', DateTimePickerFormioComponent);
